export default __webpack_public_path__ + "static/media/Creativity.b4dfe444.gif";